<template>
  <div class="card-container">
    <div class="header">
       <h3 v-if="!$slots.title" class="title">{{ $t(title) }}</h3>
       <h3> <slot name="title" /></h3>
       <a
        href="javascript:;"
        v-if="btnText"
        class="btn"
        @click="handleBtnClick">
        {{ $t(btnText) }}
      </a>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CardSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleBtnClick () {
      this.$emit('btnClick')
    }
  }
}
</script>

<style lang="less" scoped>
  .card-container {
    padding: 20px 15px;
    background-color: #FFFFFF;
    border-radius: 4px;
    .header {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      .title {
        color: #333752;
        font-size: 16px;
        font-weight: 300;
      }
      .btn {
        // color: #417AFF;
        color: @blue;
        font-size: 14px;
      }
    }
  }
</style>
